var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguageIconEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.251,
    height: 18.251,
    viewBox: "0 0 18.251 18.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6",
    transform: "translate(0.055 0.055)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(0.07 0.07)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12245",
    "data-name": "Group 12245",
    transform: "translate(0.259 1.929)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5536",
    "data-name": "Path 5536",
    d: "M244.87,191.6h9.522a9.136,9.136,0,0,0-.314-2.381H244.87Z",
    transform: "translate(-236.456 -184.456)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5537",
    "data-name": "Path 5537",
    d: "M244.87,58.033h8.183a9.173,9.173,0,0,0-2.106-2.381H244.87Z",
    transform: "translate(-236.456 -55.652)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5538",
    "data-name": "Path 5538",
    d: "M102.324,458.332a9.086,9.086,0,0,0,5.68-1.984H96.644A9.086,9.086,0,0,0,102.324,458.332Z",
    transform: "translate(-93.513 -442.065)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5539",
    "data-name": "Path 5539",
    d: "M9.844,325.163H25.416a9.071,9.071,0,0,0,1.025-2.381H8.819A9.071,9.071,0,0,0,9.844,325.163Z",
    transform: "translate(-8.819 -313.26)",
    fill: "#d80027"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5540",
    "data-name": "Path 5540",
    d: "M4.227,1.425h.832l-.774.562.3.909-.773-.562L3.034,2.9l.255-.786a9.175,9.175,0,0,0-1.77,1.973h.266l-.492.358q-.115.192-.221.39l.235.724L.869,5.236q-.164.347-.3.708l.259.8h.956L1.012,7.3l.3.909L.534,7.651l-.463.337A9.213,9.213,0,0,0,0,9.125H9.125V0A9.082,9.082,0,0,0,4.227,1.425Zm.354,6.788-.773-.562-.773.562.3-.909-.774-.562h.956l.3-.909.3.909h.956L4.285,7.3Zm-.3-3.568.3.909-.773-.562-.773.562.3-.909-.774-.562h.956l.3-.909.3.909h.956ZM7.854,8.213,7.08,7.651l-.773.562L6.6,7.3l-.774-.562h.956l.3-.909.3.909h.956L7.558,7.3Zm-.3-3.568.3.909L7.08,4.993l-.773.562.3-.909-.774-.562h.956l.3-.909.3.909h.956Zm0-2.658.3.909L7.08,2.334,6.307,2.9l.3-.909-.774-.562h.956l.3-.909.3.909h.956Z",
    transform: "translate(-0.055 -0.055)",
    fill: "#0052b4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIconEn);
export default __webpack_public_path__ + "static/media/language-icon-en.cb8e222386c8ef0ef801a071c3bc2c88.svg";
export { ForwardRef as ReactComponent };